import { gql } from '@apollo/client';

export const FETCH_TAXONOMY_SEARCH_GROUPS_GQL = gql`
  query listTaxonomySearchGroups(
    $limitOptions: Int
    $searchTerm: String
    $tenantID: ID!
  ) {
    listTaxonomySearchGroups(
      request: {
        limitOptions: $limitOptions
        searchTerm: $searchTerm
        tenantID: $tenantID
      }
    ) {
      groups {
        hasMore
        type
        options {
          displayName
          id
          category
        }
      }
    }
  }
`;
